import { BehaviorSubject, from, Observable } from "rxjs";
import { map, share } from "rxjs/operators";
import { FormItem } from "@/cs-ts-bridge/ts/form-item";
import { BaseElementDef, BaseElementDefBase } from "./BaseElementDef";
import { FormDefinitionItem } from "./__DefinitionDataInterface";
import { SectionSettings } from "@cs-ts/section-settings";
import { CalculationContext } from "./__CalculationContextInterface";

export default class SectionDef extends BaseElementDef<SectionSettings, FormDefinitionItem<SectionSettings>, FormItem> {
    declare _effectiveLabel$: Observable<string | null>;

    constructor(parentElement: BaseElementDefBase | null, elementData: FormItem, definitionData: FormDefinitionItem<SectionSettings>, calculationContext: CalculationContext) {
        super(parentElement, elementData, definitionData, calculationContext);
        this.typeName = "MI.Common.DynamicForms.Models.DFSection"; // TODO - not hardcoded?
    }

    // TODO duplicate of BaseControlDef
    /** @returns {Observable<string>} */
    effectiveLabel$() {
        if (this._effectiveLabel$ == null) {
            if (this.definition.settings.labelCalculationId) {
                this._effectiveLabel$ = this.resolveCalculation(this.definition.settings.labelCalculationId).pipe(
                    map(i => (i.length ? i[0] : null)),
                    share({ resetOnRefCountZero: true, connector: () => new BehaviorSubject(null as null | string) }),
                );
            } else {
                this._effectiveLabel$ = from([this.definition.settings.label ?? null]);
            }
        }
        return this._effectiveLabel$;
    }
}
